import React from "react";
import { Col } from "reactstrap";
import { browserName, CustomView } from "react-device-detect";
import dollarLimit from "../../../assets/img/custom/599DollarLimitNotice.jpg";
import fansBuy from "../../../assets/img/custom/FansBuy.jpg";
import badges1 from "../../../assets/img/custom/athleteHomepageNew.png";
import badges from "../../../assets/img/custom/94 cents .jpg";

import HSImage from "../../../assets/img/custom/HSimage2.avif";
import dealsOver599 from "../../../assets/img/custom/dealsOver599.png";

export default function HomeRightCol({
  isInstalled,
  toggleMemberShipModal,
  appleToggle,
  androidToggle,
}) {
  return (
    <Col lg="4" className="text-center">
      <img src={dollarLimit} className="w-100" alt="" />
      <img src={fansBuy} className="w-100" alt="" />
      <img src={badges1} className="w-100" alt="" />
      <img src={badges} className="w-100" alt="" />

      <img src={HSImage} className="w-100" alt="" />
      <img src={dealsOver599} className="w-75" style={{ maxWidth: "280px" }} alt="Deals Over 599" />

      {!isInstalled && (
        <>
          <h1 className="auth-heading">Load app to save time</h1>
          <CustomView condition={browserName === "Safari"}>
            <ul style={{ listStyle: "Number" }}>
              <li>
                <h5>
                  Choose the{" "}
                  <u>
                    <b>Share up-arrow</b>
                  </u>{" "}
                  at the bottom of your Safari screen
                </h5>
              </li>
              <li>
                <h5>
                  and select{" "}
                  <u>
                    <b>Add to Home Screen</b>
                  </u>
                </h5>
              </li>
            </ul>
          </CustomView>
          <div className="d-flex justify-content-center">
            <div className="text-dark">
              <i
                className="fab fa-apple fa-2x pointer"
                onClick={appleToggle}
              ></i>
              <br />
              <strong>Apple</strong>
              <br />
              <strong>IPhone</strong>
            </div>
            <div className="custom-border-left ml-3"></div>
            <div className="ml-3 text-dark">
              <i
                className="fab fa-android fa-2x pointer text-success"
                onClick={androidToggle}
              ></i>
              <br />
              <strong>Android + </strong>
              <br />
              <strong>Non-Apple Phones</strong>
            </div>
          </div>
        </>
      )}
    </Col>
  );
}
